import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = async (context) => ({
  redirect: {
    destination: `/admin/meetings/meet/${context.params?.quickMeetId}/new`,
    permanent: false,
  },
});

export default function AdminQuickMeetNewByIdRedirect() {
  return null;
}
